"use strict";

import React from "react";

class AssetLibraryContainer extends React.Component {
  render() {
    const style = {
      display: "flex",
      flexFlow: "row wrap",
      flex: "none",
    };

    return (
      <div>
        <div>{this.props.title}</div>
        <div style={style}>{this.props.children}</div>
      </div>
    );
  }
}

export default AssetLibraryContainer;
